// extracted by mini-css-extract-plugin
export default {"Checkout":"Checkout_Checkout__TsPtv"};